// @ts-strict-ignore
import React from 'react';
import { TouchableWithoutFeedback as RNTouchableWithoutFeedback, TouchableWithoutFeedbackProps } from 'react-native';

interface BaseTouchableProps {
  testID?: string;
}

export type TouchablePropsWithClick = {
  onClick: (e?: any, value?: any) => void;
  onPress?: (e?: any) => void;
};

export type TouchablePropsWithPress = {
  onClick?: (e?: any) => void;
  onPress: (e?: any) => void;
};
export type TouchableProps<T = TouchableWithoutFeedbackProps> =
(TouchablePropsWithClick | TouchablePropsWithPress)
& BaseTouchableProps
& T;

type ConfigurableTouchableProps<T = TouchableWithoutFeedbackProps> = TouchableProps & {
  TouchableComponent?: React.ComponentType<TouchableProps<T>>;
};

const RetypedTouchableWithoutFeedback = (
  RNTouchableWithoutFeedback as unknown as React
    .FCWithChildren<TouchableProps<TouchableWithoutFeedbackProps>>
);

/**
 * @deprecated Please use `Pressable` from `react-native` instead.
 */
const TouchableBase: React.FCWithChildren<ConfigurableTouchableProps> = ({
  onClick,
  children,
  testID,
  TouchableComponent = RetypedTouchableWithoutFeedback,
  ...props
}) => (
  <TouchableComponent
    onPress={onClick}
    testID={testID}
    {...props}
  >
    {children}
  </TouchableComponent>
);

/**
 * @deprecated Please use `Pressable` from `react-native` instead.
 */
export const TouchableWithoutFeedback: React.FCWithChildren<TouchableProps> = props => (
  <TouchableBase {...props} />
);

export default TouchableWithoutFeedback;
